import React, { useState } from "react";

import { SEND_EMAIL_CONTACT_US } from "api";
import useFetch from "utils/hooks/useFetch";

import Swal from "sweetalert2";

const Contact = () => {
  const { fetch: sendEmailContactUs } = useFetch(SEND_EMAIL_CONTACT_US);

  const [contactUsForm, setContactUsForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    inquiry: "",
  });

  const handleInputChange = (key, value) => {
    let objToSave = {
      [key]: value,
    };

    setContactUsForm((prev) => ({
      ...prev,
      ...objToSave,
    }));
  };

  const handleSendEmail = () => {
    const data = {
      full_name: contactUsForm.name,
      email_address: contactUsForm.email,
      phone_number: contactUsForm.phone,
      company_name: contactUsForm.company,
      message: contactUsForm.inquiry,
    };

    sendEmailContactUs({ data })
      .then(() => {
        setContactUsForm({
          name: "",
          email: "",
          phone: "",
          company: "",
          inquiry: "",
        });
        Swal.fire({
          text: "Success sending email.",
          icon: "success",
          position: "top-right",
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: err?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      });
  };

  return (
    <div id="contactContainer">
      <section>
        <div className="space-y-8 app-main-container">
          <section className="w-full px-6 py-16 bg-white lg:px-20">
            <div className="flex flex-col items-center justify-between max-w-6xl gap-12 mx-auto lg:flex-row">
              {/* LEFT TEXT */}
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-2xl font-bold leading-snug text-gray-900 sm:text-3xl lg:text-4xl">
                  Please fill in your enquiries, we will be in contact with you
                  shortly.
                </h2>
              </div>

              {/* RIGHT FORM */}
              <div className="flex-1 w-full max-w-md p-6 bg-white border border-gray-200 shadow-sm rounded-2xl">
                <h3 className="mb-4 text-lg font-semibold text-gray-800">
                  Get in Touch with Us!
                </h3>

                <form className="space-y-4">
                  {/* Name */}
                  <div>
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                      Name
                    </label>

                    <input
                      type="text"
                      name="name"
                      placeholder="name"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-400"
                      onChange={(e) =>
                        handleInputChange(e.target.name, e.target.value)
                      }
                      value={contactUsForm.name}
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="email@example.com"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-400"
                      onChange={(e) =>
                        handleInputChange(e.target.name, e.target.value)
                      }
                      value={contactUsForm.email}
                    />
                  </div>

                  {/* Phone */}
                  <div>
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="+62 123 456 789"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-400"
                      onChange={(e) =>
                        handleInputChange(e.target.name, e.target.value)
                      }
                      value={contactUsForm.phone}
                    />
                  </div>

                  {/* Company */}
                  <div>
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                      Company
                    </label>
                    <input
                      type="text"
                      name="company"
                      placeholder="company name"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-400"
                      onChange={(e) =>
                        handleInputChange(e.target.name, e.target.value)
                      }
                      value={contactUsForm.company}
                    />
                  </div>

                  {/* Inquiry */}
                  <div>
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                      Inquiry
                    </label>
                    <textarea
                      rows="5"
                      name="inquiry"
                      placeholder="your message"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-400"
                      onChange={(e) =>
                        handleInputChange(e.target.name, e.target.value)
                      }
                      value={contactUsForm.inquiry}
                    ></textarea>
                  </div>

                  {/* Submit Button */}
                  <div
                    className="flex justify-end pt-4 cursor-pointer"
                    onClick={() => handleSendEmail()}
                  >
                    <div className="w-full px-6 py-2 text-sm font-semibold text-white transition-all rounded-md sm:w-auto bg-[#8DC63F] hover:bg-lime-600">
                      Submit
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  );
};

export default Contact;
